export const fadeInAndUp = {
    hidden: { 
        opacity: 0,
        y: 20
    },
    visible: { 
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            delay: 2.5,
            when: "beforeChildren",
            staggerChildren: 0.2
        }
    }
}

export const fadeInAndUpNoDelay = {
    hidden: { 
        opacity: 0,
        y: 20
    },
    visible: { 
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            delay: 0.2,
            when: "beforeChildren",
            staggerChildren: 0.2
        }
    }
}

export const fadeInAndUp1Sec = {
    hidden: { 
        opacity: 0,
        y: 20
    },
    visible: { 
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            delay: 1,
            when: "beforeChildren",
            staggerChildren: 0.2
        }
    }
}

export const growIn = {
    hidden: { 
        opacity: 0,
        scale: 0
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            type: 'spring',
            duration: 1,
            delay: 0.5,
            when: "beforeChildren",
            staggerChildren: 0.5
        }
    }
}

export const growBtn = {
    hidden: { 
        opacity: 0,
        scale: 0
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            type: 'spring',
            duration: 1,
            delay: 4.5
        }
    }
}

export const growBtnSmallDelay = {
    hidden: { 
        opacity: 0,
        scale: 0
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            type: 'spring',
            duration: 1,
            delay: 2
        }
    }
}

export const growBigBtn = {
    hidden: { 
        opacity: 0,
        scale: 0
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            type: 'spring',
            duration: 1,
            delay: 1
        }
    }
}

export const fadeInAndRight = {
    hidden: { 
        opacity: 0,
        x: -50
    },
    visible: { 
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            delay: 0.5,
            when: "beforeChildren",
            staggerChildren: 0.2
        }
    }
}

export const childVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1
    }
}

export const popInCheck = {
    hidden: { 
        opacity: 0,
        scale: 0,
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            type: 'spring',
            duration: .3,
        }
    }
}